import * as React from 'react';
import { WritableAtom, atom, useSetAtom } from 'jotai';
import { unitAtom } from '@src/components/metrics-panel-hz/atoms';
import { Tabs } from '@src/store/trends/base/reducer';

export enum TABLE_MODES {
  drilldown = 'drilldown',
  filter = 'filter',
  compare = 'compare',
}

export const RESET_MODE_ATOM_VALUE = 'RESET-MODE-ATOM-VALUE';

export const useObserverResetModeValue = () => {
  const update = useSetAtom(modeAtom);

  React.useEffect(() => {
    const handler = () => {
      update(TABLE_MODES.drilldown);
    };

    window.addEventListener(RESET_MODE_ATOM_VALUE, handler);

    return () => {
      window.removeEventListener(RESET_MODE_ATOM_VALUE, handler);
    };
  }, [update]);
};

// const unitAtom = atom('#');
const heightAtom = atom('s');
const modeAtom = atom(TABLE_MODES.drilldown);
const exploreViewAtom = atom({
  show: false,
  dimension: null,
  isHighCardinality: false,
});

// local metrics
const tableMetricsAtom = atom<{ metrics: string[]; orderBy?: string | null }>({
  metrics: [],
  orderBy: null,
});

export function atomWithToggle(initialValue?: boolean): WritableAtom<boolean, [boolean?], void> {
  const anAtom = atom(initialValue, (get, set, nextValue?: boolean) => {
    const update = nextValue ?? !get(anAtom);
    set(anAtom, update);
  });
  return anAtom as WritableAtom<boolean, [boolean?], void>;
}

const isTableCompareEnabledAtom = atomWithToggle(false);
const activeTabAtom = atom(Tabs.TopTrends);
const liveDimensionIntervalAtom = atom(null);

export const dimensionSortsAtom = atom<
  Record<string, { key: string; order: 'asc' | 'desc'; type?: any }>
>({});

const dimensionPanelShareAtom = atom((get) => {
  return {
    activeTab: get(activeTabAtom),
    sorts: get(dimensionSortsAtom),
    height: get(heightAtom),
  };
});

// add atoms to persist here
const dimensionPanelPersistenceAtom = atom((get) => {
  return {};
});

export {
  unitAtom,
  heightAtom,
  modeAtom,
  tableMetricsAtom,
  exploreViewAtom,
  isTableCompareEnabledAtom,
  activeTabAtom,
  dimensionPanelShareAtom,
  dimensionPanelPersistenceAtom,
  liveDimensionIntervalAtom,
};
